// 国补城市集合页
import {
  
  WgtNewSlider,
  WgtHotZone,
  WgtHoriZontal,
  WgtFilm,
  WgtAbtest,
  
  WgtStoreRuleList,
  WgtTabsCut,
  WgtGoodsLift,
  WgtOldEvaluate,
  WgtWallPaper,
   
  WgtAroundStoreOne,
  WgtFooterNav,
  WgtProductShelves,
  WgtCustomWgt,
  
  WgtContentPart,
  WgtSuspension,

} from '../wgts/index'

export const initiWidgets = []

export const widgets = {
  
  WgtNewSlider,
  WgtHotZone,
  WgtHoriZontal,
  WgtAbtest,
  WgtFilm,
  
  WgtStoreRuleList,
  WgtTabsCut,
  WgtGoodsLift,
  WgtOldEvaluate,
  WgtWallPaper,
   
  WgtAroundStoreOne,
  WgtFooterNav,
  WgtProductShelves,
  WgtCustomWgt,
  
  WgtContentPart,
  WgtSuspension,
}


export default {
  widgets,
  initiWidgets
}
